import { createContext, ComponentChildren } from "preact";
import { useContext, useEffect, useState } from "preact/hooks";
import { getClassNames } from "../helpers/getClassNames";
import { useDarkMode } from "../hooks/useDarkMode";
import { useMargins } from "../hooks/useMargins";

export interface GlobalStateContextProps {
  isDarkMode: boolean;
  hasMargins: boolean;
  wrapperClasses: string;
}

const GlobalStateContext = createContext<GlobalStateContextProps | undefined>({
  isDarkMode: false,
  hasMargins: false,
  wrapperClasses: ""
});

export const GlobalStateProvider = ({
  children,
  ...props
}: {
  children: ComponentChildren;
}) => {
  const [wrapperClasses, setWrapperClasses] = useState("");

  const { isDarkMode } = useDarkMode();
  const { hasMargins } = useMargins();

  useEffect(() => {
    const classNames = getClassNames({ isDarkMode, hasMargins });
    setWrapperClasses(classNames);
  }, [isDarkMode, hasMargins]);

  const state = {
    wrapperClasses,
    isDarkMode,
    hasMargins,
    ...props
  };

  return (
    <GlobalStateContext.Provider value={{ ...state }}>
      {children}
    </GlobalStateContext.Provider>
  );
};

export const useGlobalState = () => {
  const context = useContext(GlobalStateContext);

  if (!context) {
    throw new Error("useGlobalState must be used within a GlobalStateProvider");
  }
  return context;
};
